/* eslint-disable react-hooks/exhaustive-deps */
import { Skeleton, Spinner, useToast } from "@chakra-ui/react";
import axios from "axios";
import classes from './survey.module.css'
import { FaSearch } from "react-icons/fa";
import 'leaflet/dist/leaflet.css'
import React, { useContext, useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Polyline, useMapEvents, useMap } from "react-leaflet";
import L from "leaflet";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import { LuArrowUpRight } from "react-icons/lu";
import MarkerClusterGroup from "react-leaflet-cluster";
import { InitiativePaginationComponent } from "../../components/initiativePaginationComponent/initiativePaginationComponent";



const url = process.env.REACT_APP_BASE_URL;

const customIconToVisit = new L.Icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/128/149/149059.png",
    iconSize: [32, 32],
});


export function SurveyTeam(params) {

    const toast = useToast()

    const [gettingTeams, setGettingTeams] = useState(false)
    const [allTeamsTotalCount, setAllTeamsTotalCount] = useState(0)
    const [allTeams, setAllTeams] = useState([]);
    const [activeTeamObject, setActiveTeam] = useState({})

    const { _id: activeTeam } = activeTeamObject || {}



    const [gettingPositions, setGettingPositions] = useState(false)
    const [positions, setPositions] = useState([]);
    const [addresses, setAddresses] = useState([]);
    const [allPositions, setAllPositions] = useState([])


    const [allTeamsFilter, setAllTeamsFilter] = useState({
        page: 1,
        limit: 10,
        search: '',
        startDate: '',
        endDate: ''
    })


    const defaultBoundingBox = [
        [4.240594, 2.676932],
        [13.885644, 14.678014]
    ]
    const [searchStreet, setSearchStreet] = useState('')

    const [boundingBox, settBoundingBox] = useState(defaultBoundingBox)
    const [fetchingCoordinates, setFetchingCoordinates] = useState(false)
    const [searchResults, setSearchResults] = useState([])


    const [searchedText, setSearchText] = useState('')

    const searchBoundary = (result) => {
        const { display_name, boundingbox } = result
        settBoundingBox([[boundingbox[0], boundingbox[2]], [boundingbox[1], boundingbox[3]]])
        setSearchText(display_name)
        setSearchResults([])
    }

    const fetchCoordinates = async (type, name) => {
        setFetchingCoordinates(true)
        try {
            const response = await fetch(
                `https://nominatim.openstreetmap.org/search?format=json&q=${searchStreet}`
            );
            const data = await response.json();
            if (data.length > 0) {
                setSearchResults(data)
            }
        } catch (error) {
            console.error("Error fetching coordinates:", error);
            const msg = error?.response?.data?.message || 'unexpected error';

            toast({
                description: msg,
                status: "error",
                position: "top"
            });
        } finally {
            setFetchingCoordinates(false)
        }
    };

    const fetchSurveyTeams = async () => {
        const config = {
            headers: {
                authorization: `Bearer ${localStorage.getItem('PRV1TK')}`,
            },
        };

        setGettingTeams(true)

        try {

            const res = await axios.get(
                `${url}/survey/maps/users/team?page=${allTeamsFilter.page}&limit=${allTeamsFilter.limit}&search=${allTeamsFilter.search}&startDate=${allTeamsFilter.startDate}&endDate=${allTeamsFilter.endDate}`,
                config
            );

            const { data } = res.data;

            setAllTeams(data.teams);
            setAllTeamsTotalCount(data.totalCount)
        } catch (error) {
            console.error("Error fetching teams:", error);
            const msg = error?.response?.data?.message || 'unexpected error';

            toast({
                description: msg,
                status: "error",
                position: "top"
            });
        } finally {
            setGettingTeams(false)
        }
    }

    const getPositions = async (teamId) => {
        const config = {
            headers: {
                authorization: `Bearer ${localStorage.getItem('PRV1TK')}`,
            },
        };

        let page = 1;
        const limit = 100;
        let allPs = [];
        let totalCount = 0;
        let hasNextPage = true;

        setGettingPositions(true)

        try {
            while (hasNextPage) {
                const res = await axios.get(
                    `${url}/survey/maps/teams/positions/${teamId}?page=${page}&limit=${limit}`,
                    config
                );

                const { data } = res.data;
                allPs = [...allPs, ...data.positions];
                totalCount = data.totalCount;

                hasNextPage = (page - 1) * limit < totalCount;
                page++;
            }


            setAllPositions(allPs);
        } catch (error) {
            console.error("Error fetching teams:", error);
            const msg = error?.response?.data?.message || 'unexpected error';

            toast({
                description: msg,
                status: "error",
                position: "top"
            });
        } finally {
            setGettingPositions(false)
        }
    };

    const [gettingDonePositions, setGettingDonePositions] = useState(false)
    const [allDonePositions, setAllDonePositions] = useState([])
    const [inputPage, setInputPage] = useState(allTeamsFilter?.page);


    const getPositionsDone = async () => {
        const config = {
            headers: {
                authorization: `Bearer ${localStorage.getItem('PRV1TK')}`,
            },
        };

        let page = 1;
        const limit = 100;
        let allPs = [];
        let totalCount = 0;
        let hasNextPage = true;

        setGettingDonePositions(true)


        try {
            while (hasNextPage) {
                const res = await axios.get(
                    `${url}/survey/maps/done/positions/${activeTeamObject?.survey?._id}?groupID=${activeTeam}&page=${page}&limit=${limit}&startDate=${positionsDate?.startDate}&endDate=${positionsDate?.endDate}`,
                    config
                );

                const { data } = res.data;
                allPs = [...allPs, ...data.positions];
                totalCount = data.totalCount;

                hasNextPage = (page - 1) * limit < totalCount;
                page++;
            }


            setAllDonePositions(allPs);
        } catch (error) {
            console.error("Error fetching teams:", error);
            const msg = error?.response?.data?.message || 'unexpected error';

            toast({
                description: msg,
                status: "error",
                position: "top"
            });
        } finally {
            setGettingDonePositions(false)
        }
    };

    useEffect(() => {
        if (activeTeam) {
            getPositions(activeTeam);
            getPositionsDone()
        }
    }, [activeTeam])


    const customIcon = new L.Icon({
        iconUrl: "https://cdn-icons-png.flaticon.com/128/2738/2738955.png",
        iconSize: [32, 32],
    });


    const customIconDone = new L.Icon({
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        shadowSize: [41, 41]
    });




    const FitToBounds = () => {
        const map = useMap();
        map.fitBounds(boundingBox || defaultBoundingBox);
        return null;
    };

    useEffect(() => {
        fetchSurveyTeams();
    }, [allTeamsFilter]);

    // todo handle pagination at a fetch all teams

    const [positionsDate, setPositionsDate] = useState({
        startDate: "",
        endDate: ''
    })


    const changePositionDate = (e) => {
        const { name, value } = e.target
        setPositionsDate((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const sanitizedDonePositions = allDonePositions?.map(item => ([item?.location?.coordinates[1], item?.location?.coordinates[0]]))



    return (
        <div className={classes.container}>

            {
                activeTeam ?
                    <>
                        <HiOutlineArrowNarrowLeft onClick={() => setActiveTeam({})} style={{ transform: "scale(1.3)", marginBottom: ".8rem", cursor: "pointer", opacity: ".8" }} />
                        <div className={classes.mapArea}>

                            <div className={classes.absoluteCard}>


                                <div className={classes.searchBarContainer}>
                                    <div className={`${classes.searchBarSubContainer} ${classes.searchWithShadow}`}>
                                        <input
                                            placeholder="Search a location to centre"
                                            type="text"
                                            className={classes.searchBar}
                                            onChange={(e) => setSearchStreet(e.target.value)}
                                        />
                                    </div>

                                    <div className={classes.faSearchContainer}>
                                        <FaSearch onClick={() => { fetchCoordinates() }} className={classes.searchIcon} />
                                    </div>
                                </div>

                                {searchResults?.length > 0 &&
                                    <div className={classes.searchResultsGrouped}>
                                        {
                                            searchResults?.map((result, index) => (

                                                <>
                                                    {
                                                        fetchingCoordinates ?
                                                            <div>
                                                                <Skeleton height={"30px"} />
                                                            </div>
                                                            :
                                                            <div onClick={() => searchBoundary(result)} className={classes.searchResultsCard} key={index}>
                                                                <p className={classes.searchResultsCardText}>{result?.display_name}</p>
                                                            </div>
                                                    }
                                                </>

                                            ))
                                        }
                                    </div>}

                            </div>

                            <div className={classes.searchBarContainer}>
                                <input name="startDate" value={positionsDate?.startDate} onChange={changePositionDate} className={classes.date} type="date" />
                                <p>-</p>
                                <input name="endDate" value={positionsDate?.endDate} onChange={changePositionDate} className={classes.date} type="date" />
                                <div style={{ background: '#ffa347' }} className={classes.faSearchContainer}>
                                    <LuArrowUpRight onClick={() => { getPositions(activeTeam) }} className={classes.searchIcon} />
                                </div>
                            </div>


                            {
                                gettingPositions ?
                                    <div className={classes.spinnerCon}>
                                        <Spinner />
                                    </div>
                                    :

                                    <>
                                        <MapContainer
                                            center={[6.4550575, 3.3941795]}
                                            zoom={30}
                                            className={classes.mapContainer}
                                        >
                                            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                                            <MarkerClusterGroup>
                                                {allPositions.map((team) =>
                                                    team.positions && team.positions.length > 1 ? (
                                                        <React.Fragment key={team._id}>
                                                            {team.positions.map((pos, idx) => (
                                                                <Marker key={`${team._id}-${idx}`} position={pos} icon={customIcon} />
                                                            ))}
                                                            <Polyline positions={[...team.positions, team.positions[0]]} color={'red'} />
                                                        </React.Fragment>
                                                    ) : null
                                                )}
                                            </MarkerClusterGroup>



                                            {allPositions.map((team, index) => (
                                                team.toVisit && team.toVisit.length > 1 ? (
                                                    <React.Fragment key={team._id}>
                                                        {team.toVisit.map((pos, idx) => (
                                                            <Marker
                                                                draggable={true}
                                                                eventHandlers={{
                                                                    // dragend: (e) => handleDoneMarkerDrag(e, index, idx, team._id, team.toVisit),
                                                                    // click: (e) => handleMarkerClick(index, e),
                                                                }}
                                                                key={`${team._id}-${idx}`} position={pos} icon={customIconToVisit} />
                                                        ))}
                                                    </React.Fragment>
                                                ) : null)
                                            )}


                                            {/* Render Clustered Markers for Sanitized Done Positions */}
                                            {sanitizedDonePositions.length > 0 && (
                                                <MarkerClusterGroup>
                                                    {/* Render Markers for Each Point */}
                                                    {sanitizedDonePositions.map((pos, index) => (
                                                        <Marker
                                                            key={`done-${index}`}
                                                            position={pos}
                                                            icon={customIconDone}
                                                        />
                                                    ))}
                                                </MarkerClusterGroup>
                                            )}

                                            {/* Render Polyline Connecting the Points in Order */}
                                            {/* {sanitizedDonePositions.length > 1 && (
                                                <Polyline
                                                    positions={sanitizedDonePositions} // Pass the array directly
                                                    color="green"
                                                />
                                            )} */}

                                            <FitToBounds />
                                        </MapContainer>






                                    </>

                            }

                        </div>
                    </>
                    :
                    <>
                        {/* <div> */}
                        {/* <input className={classes.searchInput} type="text" placeholder="Search team" onChange={e => setAllTeamsFilter({ ...allTeamsFilter, search: e.target.value })} /> */}



                        <div className={classes.listGroup2}>
                            {
                                gettingPositions ?
                                    <div className={classes.spinnerCon}>
                                        <Spinner />
                                    </div>
                                    :
                                    allTeams?.map((team, index) => (
                                        <div className={classes.individualTeamCon} key={index} onClick={() => { setActiveTeam(team); }} >
                                            <p className={classes.teamListName} >{team.name}</p>
                                            <p className={classes.teamListSurveyName}>{team.survey.name}</p>
                                        </div>

                                    ))
                            }

                            {
                                allTeams.length ? <InitiativePaginationComponent
                                    page={allTeamsFilter?.page} totalCount={allTeamsTotalCount} setSearchValues={setAllTeamsFilter} setInputPage={setInputPage} inputPage={inputPage} limit={allTeamsFilter.limit}
                                />
                                    :
                                    <></>
                            }


                        </div>
                    </>
            }
        </div>
    )
}


